






































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Student, SearchCondition } from '@/modules/student';
import { Person } from '@/models/person';
import { SchoolTypes } from '@/enums/schoolTypes';
import { GradeYears } from '@/enums/gradeYears';
import { Subject } from '@/models/subject';
import AvaivaledVue from '@/components/avaivaled.vue';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import Axios from 'axios';
import { CreditcardSettingResponse } from '@/models/creditcardSettingResponse';

interface Node {
  type: string;
  id: string;
  userId: string | null;
  name: string;
  children: Node[];
}

@Component
export default class StudentSelect extends AvaivaledVue {
  private SchoolTypes = SchoolTypes;

  @Prop({ default: 0 }) private schoolTypeFilter: number;
  @Prop() private selectedStudents: Person[];
  @Prop() private enableSubject?: Subject;

  private useCreditcard: boolean = false;
  private isPaypal: boolean = false;
  private students: Student[] = [];
  private studentsDisp = new Array<Node>();
  private defaultCheckedKey = new Array<string>();
  private showSearchCondition = true;
  private sort = 'Grade';
  private condition: SearchCondition = {
    ordinarySchoolId: '',
    gradeYear: '',
    tutorList: [],
    tagList: [],
    keyWord: '',
    creditcardRegistered: null,
    perPage: 10000000,
    page: 1,
    sort: '',
    schoolName: '',
    studentIdList: [],
  };
  private loading = false;

  @Watch('schoolTypeFilter')
  private changeSchoolTypeFilter() {
    this.loadData();
  }

  private async created() {
    this.useCreditcard = false;
    this.isPaypal = false;

    if (!this.user) {
      await this.$store.dispatch('me/fetchMyData');
    }

    switch (this.userRole) {
      case UserTypes.All:
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        if ((this.availableFunction & FunctionTypes.Bill) === FunctionTypes.Bill) {
          // 請求機能
          try {
            const res = await Axios.get<CreditcardSettingResponse>('/api/bill-settings/creditcard');
            if (res.data.enabled) {
              this.useCreditcard = true;
              this.isPaypal = res.data.isPaypal;
            }
          } catch (error) {
            //
          }
        }
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    this.loading = true;

    const data = await this.$store.dispatch('student/getSelectableStudents', this.condition).catch((error) => {
      this.loading = false;
      return { accountList: new Array<Student>() };
    });
    let students = data.accountList as Student[];
    if (this.enableSubject !== undefined) {
      const enableSubject = this.enableSubject as Subject;
      students = students.filter((student: Student) => {
        return student.subjectList.find((subject: Subject) => {
          return subject.id === enableSubject.id;
        }) !== undefined;
      });
    }

    students.forEach((student) => {
      switch (student.gradeYear) {
        case GradeYears.Kindergarten1:
        case GradeYears.Kindergarten2:
        case GradeYears.Kindergarten3:
          student.schoolId = student.ordinaryPreSchoolId;
          student.schoolName = student.ordinaryPreSchoolName;
          break;
        case GradeYears.ElementarySchool1:
        case GradeYears.ElementarySchool2:
        case GradeYears.ElementarySchool3:
        case GradeYears.ElementarySchool4:
        case GradeYears.ElementarySchool5:
        case GradeYears.ElementarySchool6:
          student.schoolId = student.ordinaryElementarySchoolId;
          student.schoolName = student.ordinaryElementarySchoolName;
          break;
        case GradeYears.MiddleSchool1:
        case GradeYears.MiddleSchool2:
        case GradeYears.MiddleSchool3:
          student.schoolId = student.ordinaryMiddleSchoolId;
          student.schoolName = student.ordinaryMiddleSchoolName;
          break;
        case GradeYears.HighSchool1:
        case GradeYears.HighSchool2:
        case GradeYears.HighSchool3:
          student.schoolId = student.ordinaryHighSchoolId;
          student.schoolName = student.ordinaryHighSchoolName;
          break;
      }
      if (!student.schoolId) {
        student.schoolId = '';
        student.schoolName = '[学校なし]';
      }
    });

    /*
      this.schoolTypeFilterにより
      「すべて」「小学」「中学」「高校」
      のいずれかでフィルタリング
    */
    if (this.schoolTypeFilter === SchoolTypes.All) {
      this.students = students;
    } else {
      this.students = students.filter((student) => {
        switch (this.schoolTypeFilter) {
          case SchoolTypes.ElementarySchool:
            switch (student.gradeYear) {
              case GradeYears.ElementarySchool1:
              case GradeYears.ElementarySchool2:
              case GradeYears.ElementarySchool3:
              case GradeYears.ElementarySchool4:
              case GradeYears.ElementarySchool5:
              case GradeYears.ElementarySchool6:
              return true;
            }
            break;
          case SchoolTypes.MiddleSchool:
            switch (student.gradeYear) {
              case GradeYears.MiddleSchool1:
              case GradeYears.MiddleSchool2:
              case GradeYears.MiddleSchool3:
              return true;
            }
            break;
          case SchoolTypes.HighSchool:
            switch (student.gradeYear) {
              case GradeYears.HighSchool1:
              case GradeYears.HighSchool2:
              case GradeYears.HighSchool3:
              return true;
            }
            break;
        }
        return false;
      });
    }

    this.setTreeNodes();

    if (!this.selectedStudents) {
      this.defaultCheckedKey = [];
    } else {
      this.defaultCheckedKey = this.selectedStudents.map((student) => student.id);
    }

    this.loading = false;
  }

  private setTreeNodes() {
    const checkedKeys = (this.$refs.tree as any).getCheckedKeys().filter((id: string) => {
      return !(id.indexOf('school-') === 0 || id.indexOf('grade-') === 0);
    });

    let students = this.students;
    switch (this.sort) {
      case 'Grade':
        students = students.sort((a, b) => {
          if (a.gradeYear < b.gradeYear) { return -1; }
          if (a.gradeYear > b.gradeYear) { return 1; }
          if (!!a.schoolId && !b.schoolId) { return -1; }
          if (!a.schoolId && !!b.schoolId) { return 1; }
          if (a.schoolName < b.schoolName) { return -1; }
          if (a.schoolName > b.schoolName) { return 1; }
          if (a.lastNameKana < b.lastNameKana) { return -1; }
          if (a.lastNameKana > b.lastNameKana) { return 1; }
          if (a.firstNameKana < b.firstNameKana) { return -1; }
          if (a.firstNameKana > b.firstNameKana) { return 1; }
          if (a.userId < b.userId) { return -1; }
          if (a.userId > b.userId) { return 1; }
          return 0;
        });
        break;
      case 'School':
        students = students.sort((a, b) => {
          if (!!a.schoolId && !b.schoolId) { return -1; }
          if (!a.schoolId && !!b.schoolId) { return 1; }
          if (a.schoolType < b.schoolType) { return -1; }
          if (a.schoolType > b.schoolType) { return 1; }
          if (a.schoolName < b.schoolName) { return -1; }
          if (a.schoolName > b.schoolName) { return 1; }
          if (a.gradeYear < b.gradeYear) { return -1; }
          if (a.gradeYear > b.gradeYear) { return 1; }
          if (a.lastNameKana < b.lastNameKana) { return -1; }
          if (a.lastNameKana > b.lastNameKana) { return 1; }
          if (a.firstNameKana < b.firstNameKana) { return -1; }
          if (a.firstNameKana > b.firstNameKana) { return 1; }
          if (a.userId < b.userId) { return -1; }
          if (a.userId > b.userId) { return 1; }
          return 0;
        });
        break;
    }
    const studentsTree = new Array<Node>();
    students.forEach((student) => {
      const schoolId = `school-${student.schoolId}`;
      const schoolName = student.schoolName;
      const gradeYear = `grade-${student.gradeYear}`;

      switch (this.sort) {
        case 'Grade': {
          let grade = studentsTree.find((item) => {
            return item.id === gradeYear;
          });
          if (!grade) {
            grade = {
              type: 'grade',
              id: gradeYear,
              userId: null,
              name: student.gradeYearName,
              children: new Array<Node>()
            };
            studentsTree.push(grade);
          }

          const schoolKey = `${schoolId}|${gradeYear}`;
          let school = grade.children.find((item) => {
            return item.id === schoolKey;
          });
          if (!school) {
            school = {
              type: 'school',
              id: schoolKey,
              userId: null,
              name: schoolName,
              children: new Array<Node>()
            };
            grade.children.push(school);
          }

          school.children.push({
            type: 'student',
            id: student.id,
            userId: student.userId,
            name: `${student.lastName}　${student.firstName}`,
            children: new Array<Node>()
          });

          break;
        }
        // case 'School'
        default: {
          let school = studentsTree.find((item) => {
            return item.id === schoolId;
          });
          if (!school) {
            school = {
              type: 'school',
              id: schoolId,
              userId: null,
              name: schoolName,
              children: new Array()
            };
            studentsTree.push(school);
          }

          const gradeKey = `${gradeYear}|${schoolId}`;
          let grade = school.children.find((item) => {
            return item.id === gradeKey;
          });
          if (!grade) {
            grade = {
              type: 'grade',
              id: gradeKey,
              userId: null,
              name: student.gradeYearName,
              children: new Array()
            };
            school.children.push(grade);
          }

          grade.children.push({
            type: 'student',
            id: student.id,
            userId: student.userId,
            name: `${student.lastName}　${student.firstName}`,
            children: new Array<Node>()
          });

          break;
        }
      }
    });
    this.studentsDisp = studentsTree;
    (this.$refs.tree as any).setCheckedKeys(checkedKeys);
  }

  private expandNodes(expanded: boolean) {
    const tree = this.$refs.tree as any;
    Object.keys(tree.store.nodesMap).map((key, index) => {
      tree.store.nodesMap[key].expanded = expanded;
    });
  }

  private checkAll() {
    const checkedNodes = new Array<string>();
    this.studentsDisp.forEach((node) => {
      checkedNodes.push(node.id);
    });
    (this.$refs.tree as any).setCheckedKeys(checkedNodes);
  }

  private checkClear() {
    (this.$refs.tree as any).setCheckedKeys([]);
  }

  private getCheckedStudents(): Person[] {
    const checkedKeys: string[] = (this.$refs.tree as any).getCheckedKeys();
    const checkedStudents = new Array();
    checkedKeys.forEach((studentId) => {
      const student = this.students.find((item) => {
        return item.id === studentId;
      });
      if (!!student) {
        checkedStudents.push({ id: studentId, name: `${student.lastName}　${student.firstName}`});
      }
    });
    return checkedStudents;
  }

  private checkChange() {
    this.$emit('checkChange');
  }

  private onChangeCondition() {
    this.loadData();
  }

}
